export default {
    isAdmin () {
        return localStorage.getItem('user.role') === 'ADMIN'
    }
}